import './App.css';
import React from 'react';
import AppRoute from './mycomponents/AppRoute'
// import Header from './mycomponents/Header';

function App() {
  return (
      <div className='App'>
        {/* <Login/> */}
        {/* <Header/> */}

        <AppRoute />
      </div>
  )
}
export default App
